<!--网点弹框搜索-->
<template>
  <div>
    <el-input type="text"
              autocomplete="off"
              v-model="siteName"
              @focus="showSitePopFunc"
              :clearable="true"
              :disabled="!editable"
    >
      <i slot="suffix" class="el-input__icon el-icon-search"
         @click="showSitePopFunc"></i>
    </el-input>

    <sitePop v-if="showSitePop"
             @commit="siteCommit"
             :visiable.sync="showSitePop"
             :param="{orgIdPath: this.orgIdPath, siteFloorLevel: this.siteFloorLevel,parentSiteId: this.parentSiteId}"
             multi="true"/>
  </div>
</template>

<script>
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue";

export default {
  name: 'sitePopSearch',
  props: {
    siteId: {
      type: [String, Number],
      required: true
    },
    siteName: {
      type: [String],
      require: true
    },
    orgId: {
      type: [String, Number],
      required: false
    },
    orgIdPath: {
      type: [String],
      required: false
    },
    orgName: {
      type: [String],
      required: false
    },
    editable: {
      type: [Boolean],
      require: false,
      default: true
    },
    parentSiteId: {
      type: [String, Number],
      required: false
    },
    siteFloorLevel: {
      type: [String, Number],
      required: false
    },
  },
  mounted() {
    if(this.siteFloorLevel != null){
      console.log("网点层级:"+this.siteFloorLevel)
    }
    if(this.parentSiteId != null){
      console.log("上级id:"+this.parentSiteId)
    }
  },
  components: {sitePop},
  data() {
    return {
      showSitePop: false,
      /*siteFloorLevel: null,
      parentSiteId: null,*/
    }
  },

  watch: {
    siteName: {
      handler(newVal) {
        if (newVal == null || newVal == '' || newVal == undefined) {
          this.$emit('update:siteId', null)
          this.$emit('update:siteName', null)
          this.$emit('valueChange')
        }
      },
      deep: true,
      immediate: false,
    }
  },


  methods: {
    showSitePopFunc() {
      if (this.editable) {
        this.showSitePop = true
      } else {
        this.showSitePop = false
      }
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.siteName = data.name
      this.$emit('update:siteId', data.id)
      this.$emit('update:siteName', data.name)
      this.$emit('update:orgId', data.orgId)
      this.$emit('update:orgIdPath', data.orgIdPath)
      this.$emit('update:orgName', data.orgName)
      this.$emit('valueChange')
    },
  },
};
</script>

<style scoped lang="scss">

</style>
